import { ForwardedRef, Ref } from "react";

/** Assign a value to a callback or object ref. */
export function assignRef<T>(ref: ForwardedRef<T> | Ref<T> | undefined, value: T | null): void {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/** One callback that fans out to every ref (parent + child when using Slot). */
export function composeRefs<T>(
  ...refs: Array<Ref<T> | ForwardedRef<T> | undefined>
): (node: T | null) => void {
  return (node: T | null) => {
    refs.forEach(ref => {
      assignRef(ref, node);
    });
  };
}
